// 韩漫分类列表
export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-happy-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'bl', name: 'BL', icon: 'ri-heart-pulse-line' },
  { slug: 'gl', name: 'GL', icon: 'ri-hearts-line' },
  { slug: 'mature', name: '都市', icon: 'ri-building-line' },
  { slug: 'school', name: '校园', icon: 'ri-book-open-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
];

export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  chapters: number;
  updatedAt: string;
  tags: string[];
}

export const hotComics: Comic[] = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20solo%20leveling%20style%20dark%20fantasy%20action%20warrior%20with%20glowing%20eyes%20holding%20dagger%20in%20dungeon%2C%20epic%20anime%20art%20style%2C%20dramatic%20lighting%2C%20manga%20cover%20aesthetic%2C%20dark%20background%20with%20neon%20accents%2C%20high%20contrast%2C%20professional%20illustration%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    description: '十年前，神秘"门"出现，连接异世界与地球。平凡少年程肖宇在经历生死考验后，获得了独特的能力——"系统"，从此踏上成为最强猎人的征途。',
    status: '连载中',
    rating: 4.9,
    views: '1250万',
    chapters: 201,
    updatedAt: '2026-08-04',
    tags: ['热血', '逆袭', '战斗', '系统'],
  },
  {
    id: 2,
    title: '女神降临',
    author: 'Yaongyi',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20beautiful%20girl%20with%20makeup%20transformation%20before%20and%20after%2C%20soft%20pastel%20colors%2C%20shojo%20anime%20art%20style%2C%20flower%20background%2C%20delicate%20illustration%2C%20romantic%20atmosphere%2C%20clean%20cover%20design%2C%20professional%20manga%20art&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    description: '因为外貌自卑的任朱静，通过化妆技巧实现了惊人的变身。在新学校里她成为了众人眼中的女神，但她的真实面貌只有少数人知道。',
    status: '已完结',
    rating: 4.8,
    views: '2100万',
    chapters: 238,
    updatedAt: '2026-07-28',
    tags: ['恋爱', '校园', '化妆', '逆袭'],
  },
  {
    id: 3,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20apocalyptic%20fantasy%20young%20man%20reading%20book%20with%20constellation%20stars%20background%2C%20mysterious%20blue%20glow%2C%20dramatic%20composition%2C%20epic%20anime%20art%20style%2C%20celestial%20theme%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    description: '金独子是唯一读完一部连载十年的网络小说的人。当小说世界变成现实，他凭借对剧情的了解，在这个末日般的世界中开始求生。',
    status: '连载中',
    rating: 4.9,
    views: '1680万',
    chapters: 189,
    updatedAt: '2026-08-05',
    tags: ['奇幻', '末日', '系统', '智斗'],
  },
  {
    id: 4,
    title: '狂王',
    author: '金弘基',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20action%20fierce%20warrior%20with%20scar%20on%20face%2C%20holding%20sword%2C%20red%20and%20black%20color%20scheme%2C%20intense%20battle%20atmosphere%2C%20dynamic%20pose%2C%20aggressive%20anime%20art%20style%2C%20blood%20moon%20background%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    description: '古代朝鲜，一个被诅咒的战士之子在乱世中崛起。他以狂野的力量和钢铁般的意志，在这片充满权谋与杀戮的土地上刻下自己的传奇。',
    status: '连载中',
    rating: 4.7,
    views: '890万',
    chapters: 156,
    updatedAt: '2026-08-03',
    tags: ['历史', '格斗', '复仇', '热血'],
  },
  {
    id: 5,
    title: '她的私生活',
    author: '金成妍',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20elegant%20woman%20in%20business%20suit%20with%20secret%20fandom%20life%2C%20dual%20identity%20theme%2C%20warm%20pink%20and%20cream%20tones%2C%20chic%20anime%20art%20style%2C%20modern%20city%20background%2C%20romantic%20comedy%20vibe%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    description: '美术馆策展人成德美表面上是完美的职场精英，私下却是狂热的偶像粉丝。当新馆长出现后，她的双重生活面临暴露的危机。',
    status: '已完结',
    rating: 4.6,
    views: '1560万',
    chapters: 176,
    updatedAt: '2026-07-15',
    tags: ['恋爱', '职场', '偶像', '喜剧'],
  },
  {
    id: 6,
    title: '梨泰院Class',
    author: '赵光真',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20business%20drama%20young%20entrepreneur%20standing%20in%20front%20of%20restaurant%20at%20night%2C%20neon%20street%20lights%2C%20determined%20expression%2C%20urban%20nightlife%20aesthetic%2C%20grounded%20anime%20art%20style%2C%20warm%20street%20lighting%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    description: '朴世路在经历丧父之痛和不公正的牢狱之灾后，在梨泰院开设了一家小酒馆，开始了向庞大餐饮集团复仇的征途，聚集了一群独特的伙伴。',
    status: '已完结',
    rating: 4.8,
    views: '1980万',
    chapters: 147,
    updatedAt: '2026-06-30',
    tags: ['励志', '创业', '复仇', '群像'],
  },
  {
    id: 7,
    title: '甜蜜家园',
    author: '金坎比 / 黄英璨',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20thriller%20apocalyptic%20monster%20survival%20teenager%20with%20monster%20arm%2C%20dark%20apartment%20building%2C%20eerie%20atmosphere%2C%20green%20ish%20dark%20tone%2C%20creepy%20anime%20art%20style%2C%20horror%20elements%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    description: '独居高中生车贤秀在搬进新的公寓后，发现世界正在陷入恐怖的怪物狂潮。人类会因内心的欲望而变异成怪物，他必须在这地狱中挣扎求生。',
    status: '已完结',
    rating: 4.9,
    views: '2350万',
    chapters: 140,
    updatedAt: '2026-07-10',
    tags: ['恐怖', '生存', '怪物', '末日'],
  },
  {
    id: 8,
    title: '再婚皇后',
    author: 'Alpha Tart',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20elegant%20queen%20in%20luxurious%20royal%20gown%20with%20golden%20crown%2C%20palace%20background%2C%20royal%20purple%20and%20gold%20accents%2C%20regal%20anime%20art%20style%2C%20dramatic%20pose%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    description: '皇后纳维耶在得知皇帝出轨后，毅然决定离婚并与邻国国王再婚。她凭借智慧与魅力，在新的国度开启了一段新的传奇人生。',
    status: '连载中',
    rating: 4.7,
    views: '1780万',
    chapters: 165,
    updatedAt: '2026-08-04',
    tags: ['宫廷', '恋爱', '逆袭', '权谋'],
  },
  {
    id: 9,
    title: '我养的恶女',
    author: 'SOWOOK',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20isekai%20beautiful%20villainess%20character%20with%20dark%20dress%20and%20red%20roses%2C%20elegant%20gothic%20aesthetic%2C%20mysterious%20atmosphere%2C%20romance%20fantasy%20anime%20art%20style%2C%20castle%20interior%20background%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-09&orientation=portrait',
    description: '穿越到小说世界成为配角后，主角发现自己不得不照顾小说中的恶女角色。然而随着相处，他逐渐发现这个恶女并非表面那般简单。',
    status: '连载中',
    rating: 4.6,
    views: '1120万',
    chapters: 132,
    updatedAt: '2026-08-02',
    tags: ['穿越', '养成', '恋爱', '奇幻'],
  },
  {
    id: 10,
    title: '神之塔',
    author: 'SIU',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20tower%20of%20god%20fantasy%20adventure%20boy%20climbing%20massive%20mysterious%20tower%2C%20epic%20scale%2C%20surreal%20landscape%2C%20adventure%20anime%20art%20style%2C%20fantasy%20world%20building%2C%20dramatic%20composition%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-10&orientation=portrait',
    description: '少年夜为了追寻挚友蕾哈尔，进入了一座神秘的高塔。在塔中每层都是一个不同的世界，他需要不断挑战试炼，结识伙伴，向着塔顶前进。',
    status: '连载中',
    rating: 4.9,
    views: '2800万',
    chapters: 589,
    updatedAt: '2026-08-05',
    tags: ['冒险', '友情', '奇幻', '长篇'],
  },
];

export const latestUpdates: Comic[] = [
  {
    id: 11,
    title: '社长大人别闹了',
    author: '李智慧',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20handsome%20CEO%20man%20and%20cute%20employee%20woman%2C%20comedy%20romantic%20atmosphere%2C%20bright%20office%20setting%2C%20modern%20anime%20art%20style%2C%20clean%20composition%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-11&orientation=portrait',
    description: '霸道社长与迷糊员工的办公室浪漫喜剧，当严肃的总裁遇上不拘小节的她，一段意想不到的办公室恋情悄然展开。',
    status: '连载中',
    rating: 4.5,
    views: '670万',
    chapters: 98,
    updatedAt: '2026-08-05',
    tags: ['恋爱', '职场', '喜剧', '霸总'],
  },
  {
    id: 12,
    title: '暗黑破坏神之怒',
    author: '朴振宇',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20action%20demon%20slayer%20with%20giant%20sword%20and%20black%20armor%2C%20red%20fiery%20background%2C%20intense%20battle%20pose%2C%20dark%20anime%20art%20style%2C%20hellish%20atmosphere%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-12&orientation=portrait',
    description: '在恶魔横行的世界里，被选中的少年继承了远古的力量。为了守护所爱之人，他踏上了与恶魔军团对抗的修罗之路。',
    status: '连载中',
    rating: 4.6,
    views: '920万',
    chapters: 145,
    updatedAt: '2026-08-05',
    tags: ['奇幻', '战斗', '热血', '黑暗'],
  },
  {
    id: 13,
    title: '小岛医生的诊疗日记',
    author: '崔秀英',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20medical%20drama%20young%20female%20doctor%20on%20small%20island%20with%20sea%20background%2C%20healing%20atmosphere%2C%20warm%20sunlight%2C%20slice%20of%20life%20anime%20art%20style%2C%20peaceful%20rural%20setting%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-13&orientation=portrait',
    description: '大城市医院的年轻女医生被派往偏远小岛工作。在那里她遇到了各色各样的岛民，在治愈他人的同时也治愈了自己的内心。',
    status: '连载中',
    rating: 4.7,
    views: '540万',
    chapters: 67,
    updatedAt: '2026-08-04',
    tags: ['治愈', '医疗', '日常', '温情'],
  },
  {
    id: 14,
    title: '剑与魔法学院',
    author: '韩基勋',
    category: 'school',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20students%20with%20swords%20and%20magic%20spells%2C%20fantasy%20school%20setting%2C%20colorful%20magic%20effects%2C%20youth%20adventure%20anime%20art%20style%2C%20bright%20castle%20interior%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-14&orientation=portrait',
    description: '考入全大陆最顶尖的剑与魔法学院后，平凡少年林天发现自己拥有罕见的双修天赋。在学院中他结实了好友与劲敌，一步步走向巅峰。',
    status: '连载中',
    rating: 4.5,
    views: '780万',
    chapters: 112,
    updatedAt: '2026-08-03',
    tags: ['学院', '魔法', '友情', '成长'],
  },
  {
    id: 15,
    title: '午夜便利店',
    author: '尹志浩',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20slice%20of%20life%20convenience%20store%20at%20night%20with%20quirky%20characters%2C%20funny%20expressions%2C%20warm%20neon%20lighting%2C%20comedy%20anime%20art%20style%2C%20urban%20night%20setting%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-15&orientation=portrait',
    description: '深夜便利店里的悲喜人生！打工青年和形形色色的夜归顾客们发生的爆笑故事，每个深夜走进便利店的人都有一筐奇葩事。',
    status: '连载中',
    rating: 4.4,
    views: '430万',
    chapters: 89,
    updatedAt: '2026-08-04',
    tags: ['搞笑', '日常', '群像', '治愈'],
  },
  {
    id: 16,
    title: '月光雕刻师',
    author: '李贤民',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20VR%20game%20fantasy%20adventure%20player%20in%20medieval%20virtual%20world%20with%20moon%20in%20sky%2C%20game%20interface%20elements%2C%20fantasy%20anime%20art%20style%2C%20epic%20landscape%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-16&orientation=portrait',
    description: '在虚拟现实游戏《皇家之路》中，主角以雕刻师这一冷门职业开始冒险。凭借独特的天赋和毅力，他在游戏世界中开辟了属于自己的传奇。',
    status: '连载中',
    rating: 4.8,
    views: '1450万',
    chapters: 234,
    updatedAt: '2026-08-05',
    tags: ['游戏', 'VR', '冒险', '成长'],
  },
];

export const bannerComics: Comic[] = [
  hotComics[0],
  hotComics[2],
  hotComics[6],
  hotComics[9],
];

export function getComicById(id: number): Comic | undefined {
  return [...hotComics, ...latestUpdates].find(c => c.id === id);
}

export function getComicsByCategory(slug: string): Comic[] {
  const allComics = [...hotComics, ...latestUpdates];
  if (slug === 'all') return allComics;
  return allComics.filter(c => c.category === slug);
}

export function getCategoryName(slug: string): string {
  const cat = categories.find(c => c.slug === slug);
  return cat ? cat.name : '全部';
}